import React from 'react';
import { Heart, Users, Vote, Share2 } from 'lucide-react';

export function About() {
    return (
        <div className="px-4 py-8">
            <div className="max-w-3xl mx-auto space-y-12">

                {/* Header */}
                <div className="text-center">
                    <div className="inline-flex items-center">
                        <h1 className="text-3xl font-bold text-slate-900">Polley</h1>
                    </div>
                    <p className="mt-4 text-lg text-slate-600">
                        A simple way to make decisions together.
                    </p>
                </div>

                {/* Features */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl p-6 shadow-md border border-slate-200 text-center">
                        <Users className="w-7 h-7 text-emerald-600 mx-auto mb-3" />
                        <h3 className="font-semibold text-slate-900 mb-2">Collaborate</h3>
                        <p className="text-slate-600 text-sm">
                            Create polls and let friends, teams, or communities have their say.
                        </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-md border border-slate-200 text-center">
                        <Vote className="w-7 h-7 text-emerald-600 mx-auto mb-3" />
                        <h3 className="font-semibold text-slate-900 mb-2">Vote Easily</h3>
                        <p className="text-slate-600 text-sm">
                            Yes, No, Maybe — fast, clear, and stress-free voting.
                        </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-md border border-slate-200 text-center">
                        <Share2 className="w-7 h-7 text-emerald-600 mx-auto mb-3" />
                        <h3 className="font-semibold text-slate-900 mb-2">Share Instantly</h3>
                        <p className="text-slate-600 text-sm">
                            Share a simple link and get everyone involved in seconds.
                        </p>
                    </div>
                    <div className="bg-white rounded-xl p-6 shadow-md border border-slate-200 text-center">
                        <Heart className="w-7 h-7 text-emerald-600 mx-auto mb-3" />
                        <h3 className="font-semibold text-slate-900 mb-2">Made with Care</h3>
                        <p className="text-slate-600 text-sm">
                            Built to feel clean, welcoming, and fun for any kind of decision.
                        </p>
                    </div>
                </div>

                {/* Closing note */}
                <div className="text-center">
                    <p className="text-slate-700 text-lg leading-relaxed">
                        Whether you’re planning dinner with friends or organizing a team event,
                        Polley makes decisions easier — and more fun — for everyone.
                    </p>
                </div>
            </div>
        </div>
    );
}
